<template>
	<div id="adjudication">
		<h1>
			<i class="fad fa-poll-people fa-fw"></i> Adjudication (Tier 1)
		</h1>
		<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
		<div v-else id="adjudication-view">
			<div id="candidates-list">
				<div id="legend">
					<div>
						<i class="fad fa-microphone fa-fw"></i> <span>Essay</span>
					</div>
					<div>
						<i class="fad fa-video fa-fw"></i> <span>Dance</span>
					</div>
					<div>
						<i class="fad fa-file-chart-pie fa-fw"></i> <span>Letter & Financials</span>
					</div>
				</div>
				<ul>
					<li v-for="candidate in candidatesList" v-bind:key="candidate.id">
						<router-link v-bind:to="'/admin/adjudication/score/' + candidate.application" v-bind:key="candidate.application">
							<div class="user-all" v-if="candidate.goal > 0 && candidate.dance > 0 && candidate.letter > 0">
								<i class="fad fa-user-check fa-fw"></i> 
							</div>
							<div>
								{{candidate.nameFirst}} {{candidate.nameLast}}
							</div>
							<div class="score-progress">
								<div v-bind:class="candidate.goal > 0 ? 'voted' : ''">
									<i class="fad fa-microphone fa-fw"></i>
								</div>
								<div v-bind:class="candidate.dance > 0 ? 'voted' : ''">
									<i class="fad fa-video fa-fw"></i>
								</div>
								<div v-bind:class="candidate.letter > 0 ? 'voted' : ''">
									<i class="fad fa-file-chart-pie fa-fw"></i>
								</div>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
			<div id="candidates-profile">
				<router-view/>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false
		}
	},
	computed: {
		candidatesList(){
			return this.$store.getters.candidatesAll
		}
	},
	methods: {
		async loadScorecard(id) {
			this.isLoading = true
			await this.$store.dispatch('loadScorecard',id)
			this.isLoading = false
		}
	},
	async created(){
		await this.$store.dispatch('loadApplicants')
		await this.loadScorecard(this.$store.getters.loggedInUser.uid)
	}
}
</script>
<style scoped>
:root {
	--ar-purple: #483751;
}

::-webkit-scrollbar {
	background-color: rgba(72,55,81,.15);
	-webkit-appearance: none;
	width: 7px;
}

::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, .5);
	box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

i.fa-spinner-third {
	float: right;
}

.router-link-active {
	font-weight: bold;
}

#adjudication h1 {
	position: fixed;
}

#adjudication-view {
	display: flex;
	justify-content: space-between;
	padding-top: 58px;
}

#legend {
	border-bottom: 1px solid var(--ar-purple);;
	display: flex;
	font-size: 1.32rem;
	padding: 9px 3px;
}

	#legend > div {
		padding: 3px 9px;
	}

#candidates-list {
	border: 1px solid var(--ar-purple);
	position: fixed;
}

	#candidates-list ul {
		max-height: 51vh;
		min-width: 345px;
		overflow-y: auto;
	}

		@media (max-width:1023px){
			#candidates-list ul {
				min-width: 310px;
			}
		}

	#candidates-list a {
		border-top: 1px solid var(--ar-purple);
		display: flex;
		justify-content: space-between;
		padding: 9px 6px;
		text-decoration: none;
		transition: all 120ms ease-in-out;
	}

		#candidates-list li:first-child a {
			border-top: 0 none;
		}

		#candidates-list a:hover {
			font-weight: bold;
			padding-left: 9px;
		}

		.user-all {
			margin-right: 6px;
		}

		.score-progress {
			display: flex;
			margin-left: auto;
		}

			.score-progress > div {
				font-size: 1.8rem;
				margin: 0 6px;
				padding-right: 3px;
			}

				@media (max-width:1023px){
					.score-progress > div {
						font-size: 1.8rem;
						margin: 0 3px;
						padding-right: 3px;
					}
				}

				.score-progress i {
					color: #ccc;
					opacity: .9;
				}

				.score-progress .voted i {
					color: var(--ar-purple);
					opacity: 1;
				}

#candidates-profile {
	margin-left: 345px;
	width: 100%;
}

	@media (max-width:1023px){
		#candidates-profile {
			margin-left: 310px;
			width: 100%;
		}
	}
</style>